/* eslint vars-on-top: "off" */
require("pwacompat");
require("enyo/css/enyo.css");
require("enyo/touch");
require("enyo-perf/LazyControl");

// Ensures that enyo's poly-fills get loaded
require("enyo/utils");

var App           = require("app/App"),
    DrawLoop      = require("enyo-ui/DrawLoop"),
    config        = require("app/config"),
    logger        = require("enyo/logger"),
    ready         = require("enyo/ready"),
    loadPolyfills = require("app/PolyFills/loadPolyfills");

// Set log level
if (config.logLevel !== undefined) {
    logger.setLogLevel(config.logLevel);
}

// Allow DrawLoop to draw while scrolling
DrawLoop.set("drawInPerformanceMode", true);

ready(function() {
    var app;

    // Start app
    loadPolyfills().then(function() {
        app = new App({
            name: "ott-client-app"
        });
        app.start();
    });
});
